import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { useStaticQuery, graphql } from 'gatsby'
import SeminarCard from 'src/components/molecules/SeminarCard'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import HeadTitle from 'src/components/atoms/HeadTitle'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import ColorButton from 'src/components/atoms/ColorButton'

const TopSeminars = () => {
  const {
    allMarkdownRemark: { edges: seminarData }
  } = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        filter: { fileAbsolutePath: { regex: "/event/" } }
        sort: { fields: [frontmatter___date], order: DESC }
        limit: 2
      ) {
        edges {
          node {
            frontmatter {
              title
              description
              thumbnail {
                childImageSharp {
                  fluid(maxWidth: 400) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              tags
              date(formatString: "YYYY.MM.DD")
            }
            fields {
              slug
            }
          }
        }
      }
    }
  `)

  const seminarCardData = seminarData.map(
    ({
      node: {
        frontmatter: { title, description, thumbnail, tags, date },
        fields: { slug: to }
      }
    }) => ({
      title,
      description,
      thumbnail,
      tags,
      date,
      to
    })
  )

  return (
    <Container>
      <HeadTitle as="h2" css={headTitleCss}>
        直近開催のセミナー
      </HeadTitle>
      <ContentsWrapper>
        <Contents>
          {seminarCardData.map(
            ({ title, description, thumbnail, tags, date, to }, i) => (
              <SeminarCard
                css={seminarCardCss}
                key={i}
                title={title}
                description={description}
                thumbnail={thumbnail}
                tags={tags}
                date={date}
                to={to}
              />
            )
          )}
        </Contents>
        <ButtonWrapper>
          <ColorButton text="すべてのセミナーを見る" to="/event/" arrow />
        </ButtonWrapper>
      </ContentsWrapper>
    </Container>
  )
}

const Container = styled.div`
  padding: ${Styles.spacing[11]} 0;
  @media screen and (min-width: ${BreakPoint.MOBILE}) {
    padding: ${Styles.spacing[14]} 0;
  }
`

const headTitleCss = css`
  text-align: center;
  margin-bottom: 38px;

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin-bottom: 15px;
  }
`

const Contents = styled.div`
  & > * + * {
    margin-top: 16px;

    @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
      margin-top: 24px;
    }
  }
`

const seminarCardCss = css`
  cursor: pointer;
`

const ButtonWrapper = styled.div`
  margin: ${Styles.spacing[11]} 0 0;
  text-align: center;
`

export default TopSeminars
